/* Electrodose: external copy of an inline script. The Liquid file sets window.edoseStickyBuyConfig and calls edoseInitStickyBuy. */
window.edoseInitStickyBuy = function () {
  var CFG = window.edoseStickyBuyConfig || {};
  var bar = document.getElementById('edose-sticky-buy');
  var productFooter = document.getElementById('edose-product-footer');
  if (!bar || window.__edoseStickyBuyInit) { return; }
  window.__edoseStickyBuyInit = true;

  var imgEl = bar.querySelector('[data-esb-img]');
  var subEl = bar.querySelector('[data-esb-sub]');
  var optEl = bar.querySelector('[data-esb-opt]');
  var atcEl = bar.querySelector('[data-esb-atc]');
  var priceEl = bar.querySelector('[data-esb-price]');
  var crossEl = bar.querySelector('[data-esb-cross]');
  var wasEl = bar.querySelector('[data-esb-was]');
  var nowEl = bar.querySelector('[data-esb-now]');
  var termsEl = bar.querySelector('[data-esb-terms]');
  var shortEl = bar.querySelector('[data-esb-short]');
  var optLabelEl = bar.querySelector('[data-esb-optlabel]');
  var verbEl = bar.querySelector('[data-esb-verb]');
  if (!optEl || !atcEl || !priceEl) { return; }
  /* what the server rendered for the default: the plan on the button and its compact line */
  var SERVER_PLAN = String(atcEl.getAttribute('data-selling-plan') || '');
  var SERVER_SHORT = shortEl ? String(shortEl.textContent || '') : '';

  var VARIANTS = { single: CFG.singleId, triple: CFG.tripleId };
  var IMAGES = {
    single: CFG.singleImage,
    triple: CFG.tripleImage
  };
  var LABELS = {
    'one-single': 'One-Time \u00b7 1 Tub',
    'sub30': 'Subscribe \u00b7 1 Tub',
    'one-triple': 'One-Time \u00b7 3 Tubs',
    'sub90': 'Subscribe \u00b7 3 Tubs'
  };
  /* The dropdown leads with the tub count: a narrow phone select shows only the first words */
  var OPT_LABELS = {
    'one-single': '1 Tub \u00b7 One-Time',
    'sub30': '1 Tub \u00b7 Subscribe',
    'one-triple': '3 Tubs \u00b7 One-Time',
    'sub90': '3 Tubs \u00b7 Subscribe'
  };
  /* Phones: the select's own text is cut off at "1 Tub · Subscr…", so a drawn copy of the
     plan name (no price; the button shows it) sits over the select. Screen readers and the
     native picker still use the select itself. */
  function paintOptLabel() {
    if (!optLabelEl) { return; }
    var t = OPT_LABELS[optEl.value] || '';
    if (optLabelEl.textContent !== t) { optLabelEl.textContent = t; }
    optLabelEl.hidden = !t;
  }
  paintOptLabel();

  /* All figures come from the offer-data JSON (snippets/edose-offer-data.liquid). */
  var DATA = null;
  try {
    var src = document.querySelector('script.edose-offer-data');
    if (src) { DATA = JSON.parse(src.textContent || src.innerHTML || 'null'); }
  } catch (err) { DATA = null; }
  if (DATA && (!DATA.packs || !DATA.packs.single || !DATA.packs.triple)) { DATA = null; }

  function firstPlanId(pack) {
    var plans = (DATA && DATA.packs[pack].plans) || [];
    return plans.length ? String(plans[0].id) : null;
  }
  function planById(pack, id) {
    var plans = (DATA && DATA.packs[pack].plans) || [];
    var i;
    for (i = 0; i < plans.length; i++) {
      if (String(plans[i].id) === String(id)) { return plans[i]; }
    }
    return plans.length ? plans[0] : null;
  }
  /* Default gift when no picker is on the page: the first gift, in size M when it is sized
     and M exists, else the first size (the rule of the buy box and of the cart). The server
     resolves it, so the terms it rendered and the line property the bar adds are the same
     gift. It is named in the full terms line and on the cart line. */
  var GIFT_DEFAULT = CFG.giftDefault || '';

  /* What ships with a subscription: theme setting edose_includes_box, blank = say nothing */
  var INCLUDES_BOX = { single: CFG.includesSingle, triple: CFG.includesTriple };
  /* the first-three-pack gift sentence (already says when it ships), blank when no gift is available */
  var SHIPS_TRIPLE = CFG.shipsTriple;
  /* free gift of the 3-pack subscription: every delivery unless the theme setting says first only */
  var GIFT_EVERY = CFG.giftEvery;
  /* The bar's own default, as the server rendered it (it follows the default purchase and
     the page: the 3-pack on the 3-pack product page, one-time there outside view=ad; the tub
     everywhere else) */
  var DEFAULT_KEY = bar.getAttribute('data-esb-default');
  if (DEFAULT_KEY !== 'sub30' && DEFAULT_KEY !== 'sub90' && DEFAULT_KEY !== 'one-triple') { DEFAULT_KEY = 'one-single'; }
  var DEFAULT_OPT = (DEFAULT_KEY === 'sub30' || DEFAULT_KEY === 'sub90') ? DEFAULT_KEY : 'one';
  var DEFAULT_PACK = (DEFAULT_KEY === 'sub90' || DEFAULT_KEY === 'one-triple') ? 'triple' : 'single';

  var state = {
    opt: DEFAULT_OPT,
    onePack: DEFAULT_PACK,
    plan30: firstPlanId('single'),
    plan90: firstPlanId('triple'),
    gift: ''
  };
  var heard = false;

  function comboKey() {
    return state.opt === 'one' ? ('one-' + state.onePack) : state.opt;
  }
  function currentPack() {
    if (state.opt === 'sub90') { return 'triple'; }
    if (state.opt === 'sub30') { return 'single'; }
    return state.onePack === 'triple' ? 'triple' : 'single';
  }
  function giftChoice() {
    /* offer data unreadable: only the gift that the terms on the bar name */
    if (!DATA) { return state.gift || ''; }
    return state.gift || window.edoseGiftChoice || GIFT_DEFAULT || '';
  }
  function cancelText(pack) {
    var t = (DATA.text && DATA.text.cancel && DATA.text.cancel[pack]) || '';
    if (t) { return t; }
    return 'renews automatically until you cancel. Manage or cancel in your account.';
  }
  function cap(s) { return s ? (s.charAt(0).toUpperCase() + s.slice(1)) : ''; }
  /* Number of deliveries charged the introductory price, and the words that go with it */
  function introOf(plan) {
    var n = plan ? parseInt(plan.introCount, 10) : 0;
    return n >= 2 ? n : 1;
  }
  function firstWords(n) { return n >= 2 ? ('first ' + n + ' deliveries') : 'first delivery'; }
  /* Compact terms line: first charge and the renewal price with its cadence. The server
     prints the same characters for the default (esb_short). */
  function shortLine(first, then, cadence, tiered, intro) {
    var each = cadence ? ('every ' + cadence) : 'per delivery';
    return tiered ? (first + (intro >= 2 ? (' for your first ' + intro + ' deliveries') : ' first delivery') + ', then ' + then + ' ' + each) : (then + ' ' + each);
  }
  /* Terms of a subscription: price, renewal price, cadence, minimum, what ships, the gift */
  function termsFor(pack, plan) {
    var each = plan.cadence ? ('every ' + plan.cadence) : 'per delivery';
    var price = plan.tiered ? (plan.first + ' on your ' + firstWords(introOf(plan)) + ', then ' + plan.recurring + ' ' + each) : (plan.recurring + ' ' + each);
    var gift = pack === 'triple' ? giftChoice() : '';
    /* "your pick" only when the gift comes from a gift picker on this page (the plan card's);
       a gift the bar adds by itself is named without it (SPEC-v5 F19) */
    var picked = !!(state.gift || window.edoseGiftChoice);
    var ships = INCLUDES_BOX[pack] || '';
    var cancel = cap(cancelText(pack));
    var t = 'Subscription: ' + price + '. ' + cancel + (cancel.toLowerCase().indexOf('your account') === -1 ? ' from your account.' : '');
    if (gift && GIFT_EVERY) {
      /* same sentence as the plan card's terms line (SPEC-v2 amendment A1) */
      t += (ships ? (' ' + ships + ' with your first delivery.') : '') + ' A free gift ships with every delivery, starting with' + (picked ? ' your pick' : '') + ': ' + gift + '.';
      return t;
    }
    if (pack === 'triple' && !gift) {
      if (SHIPS_TRIPLE) { t += ' ' + SHIPS_TRIPLE + '.'; }
      return t;
    }
    if (gift) { ships = ships ? (ships + ' + free gift') : 'Free gift'; }
    if (ships) { t += ' ' + ships + ' with your first delivery' + (gift ? (': ' + gift) : '') + '.'; }
    return t;
  }

  /* View for a page without a plan card: built from the offer data only */
  function standalone() {
    if (!DATA) { return null; }
    var sub = (state.opt === 'sub30' || state.opt === 'sub90');
    var pack = currentPack();
    var pd = DATA.packs[pack];
    var plan = sub ? planById(pack, pack === 'triple' ? state.plan90 : state.plan30) : null;
    if (sub && !plan) { sub = false; state.opt = 'one'; state.onePack = pack; }
    return {
      pack: pack,
      sub: sub,
      tiered: !!(sub && plan.tiered),
      intro: sub ? introOf(plan) : 1,
      label: LABELS[comboKey()],
      priceLabel: sub ? plan.first : pd.one.label,
      crossLabel: sub ? '' : (pd.one.cross || ''),
      priceCents: sub ? plan.firstCents : pd.one.cents,
      planId: sub ? String(plan.id) : '',
      variantId: pd.variantId || VARIANTS[pack],
      terms: sub ? termsFor(pack, plan) : '',
      brief: sub ? shortLine(plan.first, plan.recurring, plan.cadence, !!plan.tiered, introOf(plan)) : ''
    };
  }

  /* View for a page with a plan card: exactly what the card broadcast */
  function fromDetail(d) {
    var sub = (state.opt === 'sub30' || state.opt === 'sub90');
    var pack = (d.pack === 'single' || d.pack === 'triple') ? d.pack : currentPack();
    if (d.priceLabel === undefined || d.priceCents === undefined) { return standalone(); }
    /* a subscription never goes on the bar without its terms */
    if (sub && !d.terms) { return standalone(); }
    var intro = parseInt(d.introCount, 10);
    if (!(intro >= 1)) { intro = (sub && d.planId) ? introOf(planById(pack, d.planId)) : 1; }
    var tiered = !!(sub && d.thenLabel && d.thenLabel !== d.priceLabel);
    /* the compact line is built from the card's figures, not cut out of its sentence */
    return {
      pack: pack,
      sub: sub,
      tiered: tiered,
      intro: intro,
      label: d.label || LABELS[comboKey()],
      priceLabel: d.priceLabel,
      crossLabel: d.crossLabel || '',
      priceCents: d.priceCents,
      planId: (sub && d.planId) ? String(d.planId) : '',
      variantId: VARIANTS[pack],
      terms: d.terms || '',
      brief: sub ? shortLine(d.priceLabel, d.thenLabel || d.priceLabel, d.cadence || '', tiered, intro) : ''
    };
  }

  /* View copied from the plan card's button. Used only when the offer data cannot be read.
     A subscription is copied only together with the terms the card prints under its button;
     without them the bar keeps its own server-rendered default. The gift is added only when
     those terms name it, so the bar adds what it shows. */
  function fromCardButton() {
    var b = document.getElementById('epdp-atc');
    if (!b) { return null; }
    var planId = String(b.getAttribute('data-selling-plan') || '');
    var vid = String(b.getAttribute('data-variant-id') || '');
    var pack = vid === String(VARIANTS.triple) ? 'triple' : (vid === String(VARIANTS.single) ? 'single' : '');
    var p = b.querySelector('[data-price]');
    var c = b.querySelector('[data-cross]');
    var cents = parseInt(b.getAttribute('data-price-cents'), 10);
    if (!pack || !p || !p.textContent || !(cents > 0)) { return null; }
    var terms = '';
    var gift = '';
    if (planId) {
      var t = document.getElementById('epdp-terms');
      terms = t ? String(t.textContent || '').replace(/^\s+|\s+$/g, '') : '';
      if (!terms) { return null; }
      var pill = pack === 'triple' ? document.querySelector('#epdp-gift .opt-gift-pill[aria-checked="true"]') : null;
      var size = document.getElementById('epdp-gift-size');
      if (pill) {
        gift = pill.getAttribute('data-gift') || '';
        if (gift && pill.getAttribute('data-sized') === '1' && size && size.value) { gift += ' (' + size.value + ')'; }
        if (!gift || terms.indexOf(gift) === -1) { gift = ''; }
      }
    }
    state.opt = planId ? (pack === 'triple' ? 'sub90' : 'sub30') : 'one';
    state.onePack = pack;
    state.gift = gift;
    return {
      pack: pack,
      sub: !!planId,
      tiered: false,
      intro: 1,
      keepOptionText: !!planId,
      label: LABELS[comboKey()],
      priceLabel: p.textContent,
      crossLabel: planId ? '' : (c ? c.textContent : ''),
      priceCents: cents,
      planId: planId,
      variantId: vid,
      terms: terms,
      /* no figures to build from: the server's compact line when the card's button is on
         the plan the server rendered the bar for, else the card's own sentence */
      brief: planId ? ((planId === SERVER_PLAN && SERVER_SHORT) ? SERVER_SHORT : terms) : ''
    };
  }

  function paint(v) {
    if (!v) { return; }
    priceEl.textContent = v.priceLabel;
    if (crossEl) { crossEl.textContent = v.crossLabel; }
    /* hidden words, so a struck price and the real price are never read as one string */
    if (wasEl) { wasEl.textContent = v.crossLabel ? 'was ' : ''; }
    if (nowEl) { nowEl.textContent = v.crossLabel ? ', now ' : ''; }
    atcEl.setAttribute('data-price-cents', String(v.priceCents));
    atcEl.setAttribute('data-variant-id', String(v.variantId));
    atcEl.setAttribute('data-selling-plan', v.planId || '');
    if (termsEl && termsEl.textContent !== v.terms) { termsEl.textContent = v.terms; }
    if (shortEl && shortEl.textContent !== (v.brief || '')) { shortEl.textContent = v.brief || ''; }
    if (subEl) { subEl.textContent = v.label; }
    /* 2026-10-13: the button names the purchase type, so One-Time and Subscription never share a label */
    if (verbEl) { verbEl.textContent = v.sub ? 'Add Subscription' : 'Add One-Time'; }
    if (imgEl && IMAGES[v.pack] && imgEl.getAttribute('src') !== IMAGES[v.pack]) { imgEl.setAttribute('src', IMAGES[v.pack]); }
    var key = comboKey();
    var o = optEl.querySelector('option[value="' + key + '"]');
    if (o) {
      /* keepOptionText: copied from the card's button, the server-rendered label stays */
      if (!v.keepOptionText) { o.textContent = OPT_LABELS[key] + ' \u2014 ' + v.priceLabel + (v.tiered ? (' ' + firstWords(v.intro)) : ''); }
      optEl.value = key;
    }
    paintOptLabel();
    if (productFooter) { liftAboveBottomBars(); }
  }

  /* Plan card → bar */
  document.addEventListener('edose:purchase-change', function (e) {
    var d = (e && e.detail) || {};
    heard = true;
    if (d.opt === 'one' || d.opt === 'sub30' || d.opt === 'sub90') { state.opt = d.opt; }
    if (d.onePack === 'single' || d.onePack === 'triple') { state.onePack = d.onePack; }
    if (d.planId) {
      if (state.opt === 'sub90') { state.plan90 = String(d.planId); }
      if (state.opt === 'sub30') { state.plan30 = String(d.planId); }
    }
    if (d.gift !== undefined) { state.gift = d.gift || ''; }
    paint(fromDetail(d));
  });

  /* Ask the plan card (if any) for the state. Nobody answering = no plan card. */
  function sync(detail) {
    heard = false;
    document.dispatchEvent(new CustomEvent('edose:purchase-select', { detail: detail }));
    if (heard) { return; }
    var v = standalone();
    if (v) { paint(v); return; }
    /* Nobody answered and the offer data is unreadable: nothing can be re-priced, so lock
       the dropdown. A plan card in that state keeps only its server-rendered default
       option; show what its button shows. Without a card the bar keeps its own
       server-rendered default, terms line included. Either way the button adds exactly
       what it shows. */
    state.opt = DEFAULT_OPT;
    state.onePack = DEFAULT_PACK;
    /* the server-rendered 3-pack subscription names the default gift in its terms */
    state.gift = DEFAULT_KEY === 'sub90' ? GIFT_DEFAULT : '';
    v = fromCardButton();
    if (v) { paint(v); } else { optEl.value = DEFAULT_KEY; }
    optEl.disabled = true;
    paintOptLabel();
  }

  optEl.addEventListener('change', function () {
    paintOptLabel();
    var v = optEl.value;
    if (v.indexOf('one-') === 0) {
      state.opt = 'one';
      state.onePack = v === 'one-triple' ? 'triple' : 'single';
    } else if (v === 'sub30' || v === 'sub90') {
      state.opt = v;
      state.onePack = v === 'sub90' ? 'triple' : 'single';
    }
    sync({ opt: state.opt, onePack: state.onePack });
  });

  /* Add to cart reads what the button declares. Mechanics unchanged. */
  atcEl.addEventListener('click', function () {
    if (window.edoseSaleGuard && !window.edoseSaleGuard.check()) { return; }
    var primaryButton = document.getElementById('epdp-atc');
    if (primaryButton) { primaryButton.click(); return; }
    var id = parseInt(atcEl.getAttribute('data-variant-id'), 10);
    if (!id) { return; }
    var item = { id: id, quantity: 1 };
    var plan = atcEl.getAttribute('data-selling-plan');
    if (plan) {
      item.selling_plan = plan;
    }
    atcEl.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) { throw new Error('add failed'); }
      window.location.href = '/cart';
    }).catch(function () {
      atcEl.disabled = false;
      alert('Sorry, something went wrong adding to cart. Please try again.');
    });
  });

  /* pageshow fires on every load and on a return from the back/forward cache, after the
     browser has restored form fields. Re-enable the button (it is disabled during the add
     that leads to /cart), close the header's cart drawer if the page came back from the
     cache with it open, and re-align the dropdown with the state the button describes. */
  window.addEventListener('pageshow', function (e) {
    atcEl.disabled = false;
    if (e && e.persisted && typeof window.edoseCloseCart === 'function') {
      try { window.edoseCloseCart(); } catch (err) {}
    }
    sync({});
  });

  /* Keep above any other full-width bar fixed to the bottom (e.g. Shopify's draft-preview toolbar) */
  function liftAboveBottomBars() {
    var offset = 0;
    document.querySelectorAll('body > *').forEach(function (el) {
      if (el === bar || el.contains(bar)) { return; }
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') { return; }
      var r = el.getBoundingClientRect();
      if (r.height > 20 && r.height < 140 && r.width > window.innerWidth * 0.85 && Math.abs(r.bottom - window.innerHeight) < 6) {
        offset = Math.max(offset, r.height);
      }
    });
    bar.style.bottom = offset + 'px';
    if (productFooter) {
      productFooter.style.paddingBottom = Math.ceil(bar.getBoundingClientRect().height + offset + 16) + 'px';
    }
  }
  [400, 1500, 4000].forEach(function (t) { setTimeout(liftAboveBottomBars, t); });
  window.addEventListener('resize', liftAboveBottomBars, { passive: true });

  /* Visibility: on pages with a buy box wait until its ATC scrolls past; elsewhere show after 400px.
     Some layouts scroll the document, others scroll inside div.page-wrapper — window scroll events
     never fire for the latter, so also listen in the capture phase on document (catches scroll
     events from any inner scroller) and read scrollTop from whichever container actually moved. */
  if (bar.parentElement !== document.body) { document.body.appendChild(bar); }
  function scrolledAmount() {
    var inner = document.querySelector('.page-wrapper');
    return Math.max(
      window.scrollY || 0,
      document.scrollingElement ? document.scrollingElement.scrollTop : 0,
      inner ? inner.scrollTop : 0
    );
  }
  function updateSticky() {
    var anchor = document.getElementById('epdp-atc');
    var show = anchor ? anchor.getBoundingClientRect().bottom < 0 : scrolledAmount() > 400;
    var wasShown = bar.dataset.stuck === 'true';
    bar.dataset.stuck = show ? 'true' : 'false';
    if (productFooter && show !== wasShown) { liftAboveBottomBars(); }
  }
  window.addEventListener('scroll', updateSticky, { passive: true });
  document.addEventListener('scroll', updateSticky, { capture: true, passive: true });
  window.addEventListener('resize', updateSticky, { passive: true });
  updateSticky();
  sync({});
};
